<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="Clave"
      label="Clave"
      type="text"
      v-model="formData.Clave"
      :required="true"
      :maxlength="50"
      :disabled="isEditing"
      helpText="Código único del departamento"
    />
    
    <!-- Campo EmpresaId oculto - se captura automáticamente -->
    <input type="hidden" v-model="formData.EmpresaId" />
    
    <FormField
      id="NombreDepartamento"
      label="Nombre del Departamento"
      type="text"
      v-model="formData.NombreDepartamento"
      :required="true"
      :maxlength="50"
      helpText="Nombre del departamento"
    />
    
    <FormField
      id="Ceco1"
      label="Centro de Costo 1"
      type="text"
      v-model="formData.Ceco1"
      :maxlength="50"
      helpText="Primer centro de costo asociado"
    />
    
    <FormField
      id="Ceco2"
      label="Centro de Costo 2"
      type="text"
      v-model="formData.Ceco2"
      :maxlength="50"
      helpText="Segundo centro de costo asociado"
    />
    
    <FormField
      id="Ceco3"
      label="Centro de Costo 3"
      type="text"
      v-model="formData.Ceco3"
      :maxlength="50"
      helpText="Tercer centro de costo asociado"
    />
    
    <FormField
      id="Ceco4"
      label="Centro de Costo 4"
      type="text"
      v-model="formData.Ceco4"
      :maxlength="50"
      helpText="Cuarto centro de costo asociado"
    />
    
    <FormField
      id="Ceco5"
      label="Centro de Costo 5"
      type="text"
      v-model="formData.Ceco5"
      :maxlength="50"
      helpText="Quinto centro de costo asociado"
    />
    
    <FormField
      id="DepartamentoIdPadre"
      label="ID Departamento Padre"
      type="number"
      v-model="formData.DepartamentoIdPadre"
      helpText="Identificador del departamento padre"
    />
    
    <FormField
      id="EmpleadoIdResponsable"
      label="ID Empleado Responsable"
      type="number"
      v-model="formData.EmpleadoIdResponsable"
      helpText="Identificador del empleado responsable"
    />
    
    <FormField
      id="Nivel"
      label="Nivel"
      type="number"
      v-model="formData.Nivel"
      :required="true"
      helpText="Nivel jerárquico del departamento"
    />
    
    <FormField
      id="Descripcion"
      label="Descripción"
      type="textarea"
      v-model="formData.Descripcion"
      :maxlength="200"
      helpText="Descripción detallada del departamento"
    />
    
    <FormField
      id="EsActivo"
      label="Estado"
      type="checkbox"
      v-model="formData.EsActivo"
      checkboxLabel="Departamento activo"
      helpText="Indica si el departamento está activo en el sistema"
    />
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatDepartamentoForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    departamento: {
      type: Object,
      default: () => ({
        Clave: '',
        EmpresaId: 1,
        NombreDepartamento: '',
        Ceco1: '',
        Ceco2: '',
        Ceco3: '',
        Ceco4: '',
        Ceco5: '',
        DepartamentoIdPadre: 0,
        EmpleadoIdResponsable: 0,
        Nivel: 0,
        Descripcion: '',
        EsActivo: true
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.departamento }
    };
  },
  watch: {
    departamento: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>